import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

export default class transfersView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration
        var type = ''; // Variable to store transfer type

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a1',
                            cols: [
                                {
                                    view: 'text', // Input for Amount
                                    name: 'Amount',
                                    type: 'number',
                                    label: _('Valor'), // Localized label
                                    labelPosition: 'top',
                                    required: true,
                                    invalidMessage: _('Valor Invalido'), // Error message
                                },
                            ],
                        },
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a1',
                            cols: [
                                {
                                    view: 'text', // Input for Amount Confirmation
                                    name: 'AmountConfirm',
                                    type: 'number',
                                    label: _('Confirmar Valor'), // Localized label
                                    labelPosition: 'top',
                                    required: true,
                                    invalidMessage: _('Valor Invalido'), // Error message
                                },
                            ],
                        },
                    ],
                },
            ],
        };

        this.on(this.app, 'transfertSelected', (filter) => {
            // Event listener for transfer selection
            type = filter.id; // Set transfer type based on selection
        });

        const buttons = {
            // Button section of the form
            margin: 10,
            cols: [
                { id: 'grav', gravity: 1 }, // Placeholder for button
                {
                    view: 'button', // Button for submission
                    value: _('Retraer'), // Localized button text
                    type: 'form',
                    width: screen == 'small' ? 0 : 130, // Conditional width based on screen size
                    minWidth: 200,
                    click: () => {
                        // Click event handler
                        if ($$('formPagoPremio').validate()) {
                            // Validate form
                            const newRecarga = this.getRoot().getValues(); // Get form values
                            const cur_user = this.getParam('user', true); // Get current user parameter
                            var vthis = this; // Reference to the current context

                            if (newRecarga.Amount === newRecarga.AmountConfirm) {
                                // Check if amounts match
                                webix.confirm({
                                    // Confirmation dialog
                                    type: 'confirm-warning',
                                    text:
                                        _('Advertencia!') +
                                        '<br/>' +
                                        _('Confirme retracción de ') +
                                        newRecarga.Amount +
                                        ' ' +
                                        newRecarga.Currency +
                                        _(' para el usuario ') +
                                        newRecarga.Name,
                                    ok: _('Retraer'),
                                    cancel: _('Salir'),
                                    callback: function (action) {
                                        // Callback for confirmation
                                        if (action === true) {
                                            // If confirmed
                                            const data = {
                                                // Data to send in the request
                                                Id: newRecarga.Id,
                                                Type: '1',
                                                Amount: newRecarga.Amount,
                                                AmountConfirm: newRecarga.AmountConfirm,
                                            };
                                            webix
                                                .ajax() // AJAX request to the server
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(devConfig.geturlApi() + 'Agent/MakeAgentRetraction', data, {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error handling
                                                        webix.message(_('¡Error!'));
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success handling
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            // Check for errors in response
                                                            webix.message({
                                                                title: _('¡Error!'),
                                                                type: 'alert-error',
                                                                text: _('Ocurrio un error, comuniquese con soporte'),
                                                            });
                                                        } else {
                                                            webix.message(_('Guardado')); // Success message
                                                            webix
                                                                .ui({
                                                                    // Show window with PDF
                                                                    view: 'window',
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label: _('Factura'),
                                                                            },
                                                                            {
                                                                                view: 'button',
                                                                                label: 'X',
                                                                                width: 100,
                                                                                align: 'right',
                                                                                click: "$$('windowfact2').close();", // Close button
                                                                            },
                                                                        ],
                                                                    },
                                                                    id: 'windowfact2',
                                                                    width: 800,
                                                                    height: 500,
                                                                    modal: true,
                                                                    position: 'center',
                                                                    body: {
                                                                        rows: [
                                                                            {
                                                                                template:
                                                                                    '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // PDF iframe
                                                                            },
                                                                        ],
                                                                    },
                                                                })
                                                                .show();

                                                            var reader = new FileReader(); // FileReader for PDF
                                                            reader.onload = function (event) {
                                                                // On load event
                                                                $$('pdf').clear(); // Clear previous PDF
                                                                $$('pdf').parse({
                                                                    data: event.target.result, // Load new PDF data
                                                                });
                                                            };

                                                            function b64toBlob(b64Data, contentType, sliceSize) {
                                                                // Convert base64 to Blob
                                                                contentType = contentType || '';
                                                                sliceSize = sliceSize || 512;
                                                                var byteCharacters = atob(b64Data); // Decode base64
                                                                var byteArrays = [];
                                                                for (
                                                                    var offset = 0;
                                                                    offset < byteCharacters.length;
                                                                    offset += sliceSize
                                                                ) {
                                                                    var slice = byteCharacters.slice(
                                                                        offset,
                                                                        offset + sliceSize,
                                                                    );
                                                                    var byteNumbers = new Array(slice.length);
                                                                    for (var i = 0; i < slice.length; i++) {
                                                                        byteNumbers[i] = slice.charCodeAt(i);
                                                                    }
                                                                    var byteArray = new Uint8Array(byteNumbers);
                                                                    byteArrays.push(byteArray);
                                                                }
                                                                var blob = new Blob(byteArrays, {
                                                                    type: contentType,
                                                                }); // Create Blob
                                                                return blob;
                                                            }

                                                            var contentType = 'application/pdf'; // PDF content type
                                                            var b64Data = json.Pdf; // Base64 PDF data
                                                            var blob = b64toBlob(b64Data, contentType); // Convert to Blob
                                                            var file = window.URL.createObjectURL(blob); // Create object URL
                                                            document.querySelector('iframe').src = file; // Set iframe source
                                                            var printWindow = window.open(
                                                                file,
                                                                '',
                                                                'width=800,height=500',
                                                            ); // Open print window
                                                            printWindow.print(); // Print the document
                                                            vthis.getRoot().clear(); // Clear form
                                                            webix.html.removeCss($$('button1').$view, 'green'); // Remove CSS class
                                                            webix.html.removeCss($$('button2').$view, 'green'); // Remove CSS class
                                                            $$('formPagoPremio1').hide(); // Hide form
                                                            $$('formPagoPremio').hide(); // Hide form
                                                            $$('formPago').hide(); // Hide form
                                                            $$('back-button').hide(); // Hide back button
                                                            $$('consult-section').show(); // Show consult section
                                                            vthis.app.callEvent('TransferAgentSuccess', []); // Trigger success event
                                                        }
                                                    },
                                                });
                                        }
                                    },
                                });
                            } else {
                                webix.message({
                                    // Error message for amount mismatch
                                    title: _('¡Error!'),
                                    type: 'alert-error',
                                    text: _('Los montos no coinciden'),
                                });
                            }
                        } else {
                            webix.message({
                                // Error message for incomplete fields
                                title: _('¡Error!'),
                                type: 'alert-error',
                                text: _('Completa los campos...'),
                            });
                        }
                    },
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container',
            height: screen == 'small' ? 150 : 0, // Conditional height based on screen size
            cols: [left],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            id: 'formPagoPremio',
            rows: [upper_section, buttons],
            rules: {
                // Validation rules for form fields
                Amount: function (value) {
                    return value >= 0; // Amount must be non-negative
                },
                AmountConfirm: function (value) {
                    return value >= 0; // Amount confirmation must be non-negative
                },
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formPagoPremio').hide(); // Hide the form initially
        this.on(this.app, 'agentForm:data', (premio) => {
            // Event listener for agent form data
            form.setValues(premio); // Set form values from premio data
            console.log('premio', premio); // Log premio data
        });
        webix.ready(function () {
            // Check screen width on ready
            if (screen.width < 500) {
                $$('grav').hide(); // Hide button if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
